import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'isNot',
})
export class IsNotPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? '是' : '否';
  }
}
